import React, { Suspense, useState, useEffect } from 'react'
import { HashRouter, Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import GoogleAnalyticsReporter from '../components/analytics/GoogleAnalyticsReporter'
import TopBakery from '../components/TopBakery'
import Header from '../components/Header'
// import Nav from '../components/ColumnNav/Nav'
// import FoldNav from '../components/ColumnNav/FoldNav'
import { MEDIA_WIDTHS } from '../theme'

import Popups from '../components/Popups'
import Web3ReactManager from '../components/Web3ReactManager'
import DarkModeQueryParamReader from '../theme/DarkModeQueryParamReader'
import AddLiquidity from './AddLiquidity'
import {
  RedirectDuplicateTokenIds,
  RedirectOldAddLiquidityPathStructure,
  RedirectToAddLiquidity
} from './AddLiquidity/redirects'
import MigrateV1 from './MigrateV1'
import MigrateV1Exchange from './MigrateV1/MigrateV1Exchange'
import RemoveV1Exchange from './MigrateV1/RemoveV1Exchange'
import Pool from './Pool'
import PoolFinder from './PoolFinder'
import RemoveLiquidity from './RemoveLiquidity'
import { RedirectOldRemoveLiquidityPathStructure } from './RemoveLiquidity/redirects'
import Swap from './Swap'
import { RedirectPathToSwapOnly, RedirectToSwap } from './Swap/redirects'

// bakery
import YamProvider from '../contexts/YamProvider'
import TransactionProvider from '../contexts/Transactions'
import FarmsProvider from '../contexts/Farms'
import ModalsProvider from '../contexts/Modals'

// import LimitIp from './LimitIp'

// import Home from './Home'
import NewHome from './Home/index_new'
import Bakery from './Bakery'
import Bread from './Bakery/bread'
import BreadTen from './Bakery/breadTen'
import BreadNFT from './Bakery/breadNFT'
import Stake from './Bakery/stake'
import Tenstake from './Bakery/tenstake'
import Eth2 from './Bakery/eth2'
import Spring from './Bakery/spring'
import eth2Child from './Bakery/eth2Child'
import BodyFooter from '../components/bakery/BodyFooter'

// info
// import Info from './Info/artworkInfo'
import Info from './ArtworkInfo'

// Restaurant
import Restaurant from './Restaurant'
import MyDishes from './Restaurant/mydishes'
import ExchangeTop from './Restaurant/exchangeTop'
import Exchange from './Restaurant/exchange'

// Combo
import ComboTop from './Combo/comboTop'
import GamSoccer from './Combo/soccer'
// import MySoccer from './Soccer/mySoccer'
import BakerySoccer from './Soccer/bakerySoccer'
import BakerySoccerInfo from './Soccer/artworkInfo'
import GameBox from './Combo/gameBox'

// Poker Blindbox
import Poker from './Poker/poker'
// import MyPoker from './Poker/myPoker'
import PokerNft from './Poker/pokerNft'

// Car
import Car from './Car/car'
// import MyCar from './Car/myCar'
import RareCarNFT from './Car/rareCar'

// Gifbox
import Gifbox from './Gifbox/gifbox'
import MyGiftBox from './Gifbox/MyGiftBox'

// BSC Game Box
import MyGameBox from './GameBox/myGameBox'

// Doggies
import Doggies from './Doggies/doggies'
// import MyDoggies from './Doggies/myDoggies'
import DoggyNft from './Doggies/doggyNft'
// import DoggyNftInfo from './Doggies/doggiesInfo'

// Barking
import Barking from './Barking/barking'
// import MyBarking from './Barking/myBarking'
import BarkingNft from './Barking/barkingNft'

// Doggy Equipments
import DoggyEquiments from './DoggyEquipments/equipments'
// import MyDoggyEquipments from './DoggyEquipments/myDoggyEquipments'
import DoggyEquipments from './DoggyEquipments/doggyEquipments'

// YooshiNft
import YooshiNft from './Yooshi/yooshiNft'
// import MyYooshi from './Yooshi/myYooshi'

// Matrix
import Matrix from './Matrix/matrix'
import MatrixInfo from './Matrix/matrixInfo'

// MatrixTest
import BakeMuskMixer from './BakeMuskMixer/bakeMuskMixer'
import BakeMuskMixerInfo from './BakeMuskMixer/bakeMuskMixerInfo'

// Musk USM LAND
import MuskUsmLand from './MuskUsmLand/muskUsmLand'
import GameAce from './GameAce'



// Toy
import ToyNft from './Toy/digitalArtworks'
// import MyToy from './Toy/myArtworks'
import ToyInfo from './Toy/artworkInfo'

// Kaka
import KakaNft from './Kaka/digitalArtworks'
// import MyKaka from './Kaka/myArtworks'
import KakaInfo from './Kaka/artworkInfo'

// UserCenter
// import UserCenter from './UserCenter/index'
import PersonalInfo from './UserCenter/PersonalInfo'
import UserCenterV2 from './UserCenterV2/index'



// IDO
// import IDOComingSoon from './Ido/ComingSoon'
// import BattlePets from './Ido/BattlePets'
// import Participate from './Ido/Participate'
// import Blink from './Ido/Blink'
// import Shield from './Ido/Shield'
// import Defi100 from './Ido/Defi100'
// import Spartan from './Ido/Spartan'
// import Diesel from './Ido/Diesel'
// import Soccer from './Ido/Soccer'
// import Gamyfi from './Ido/Gamyfi'
// import HyFi from './Ido/HyFi'
// import PetPoker from './Ido/PetPoker'
// import RareCar from './Ido/RareCar'
// import CryptoDoggies from './Ido/CryptoDoggies'
// import Tokau from './Ido/Tokau'
// import XMS from './Ido/Xms'
// import GAT from './Ido/Gat'

// PET
import PetEggs from './Pet/petEggs'
import MyEggs from './Pet/myEggs'

//weapons
import Weapons from './weapons/weapons'
import MyWeapons from './weapons/myWeapons'

// Digital Artworks
import DigitalArtworks from './Artworks/digitalArtworks'
// import MyArtworks from './Artworks/myArtworks'
import ArtworkInfo from './Artworks/artworkInfo'

// Binance NFT
import Binance from './binance/binanceNft'
// import MyBinance from './binance/myBinanceNft'

// BakeryArtworks
import NewArtworks from './BakeryArtworks/digitalArtworks'
import MyNewArtworks from './BakeryArtworks/myArtworks'
import NewArtworkInfo from './BakeryArtworks/artworkInfo'
import BSCNewArtworkInfo from './BakeryArtworks/bscArtworkInfo'
import mintArtworks from './BakeryArtworks/mintArtworks'

// Musk & Doge
import MuskDoges from './MuskDoge/digitalArtworks'
// import MyMuskDoges from './MuskDoge/myArtworks'
import MuskDogeInfo from './MuskDoge/artworkInfo'
import mintMuskDoge from './MuskDoge/mintArtworks'

// MEME NFT
import MeMes from './MeMe/digitalArtworks'
// import MyMeMes from './MeMe/myArtworks'
import MeMeInfo from './MeMe/artworkInfo'
import mintMeMe from './MeMe/mintArtworks'

// Seascapes NFT
import Seascapes from './Seascape/digitalArtworks'
// import MySeascapes from './Seascape/myArtworks'
import SeascapeInfo from './Seascape/artworkInfo'
import mintSeascape from './Seascape/mintArtworks'

// inch
import OneInchs from './OneInch/digitalArtworks'
// import MyOneInchs from './OneInch/myArtworks'
import OneInchInfo from './OneInch/artworkInfo'
import mintOneInch from './OneInch/mintArtworks'

// Pets
import Pets from './Pets/pets'
import MyPets from './Pets/myPets'

// Tko Nft
import TkoNft from './TkoNft/tkoNft'
// import MyTkoNft from './TkoNft/myTkoNft'
import TkoNftInfo from './TkoNft/artworkInfo'

// other
import SfpNft from './Sfp/digitalArtworks'
// import MySfpNft from './Sfp/myArtworks'
import SfpNftInfo from './Sfp/artworkInfo'
import mintSfp from './Sfp/mintArtworks'

// 520nft
import Love from './520nft/digitalArtworks'
// import MyLove from './520nft/myArtworks'
import LoveInfo from './520nft/artworkInfo'
import mintLove from './520nft/mintArtworks'

// racanft
import RacaNft from './RacaNft/digitalArtworks'
// import MyRacaNft from './RacaNft/myArtworks'
import RacaNftInfo from './RacaNft/artworkInfo'
import mintRacaNft from './RacaNft/mintArtworks'

// bondlyNft
import bondlyNft from './bondlyNft/digitalArtworks'
// import MyBondlyNft from './bondlyNft/myArtworks'
import bondlyInfo from './bondlyNft/artworkInfo'

// tokauNft
import tokauNft from './Tokau/digitalArtworks'
// import MyTokauNft from './Tokau/myArtworks'


// 公用的市场页面
import PublicDigitalArtworks from './DigitalArtworks'
import mintPublicArtwork from './DigitalArtworks/mintArtwork'

import Collection from './Collection'
import MyArtwork from './MyArtwork'
import Explore from './Explore'
import DropsAbduction from './Drops/abduction'
import DropsAsap from './Drops/asap'
import DropsSergi from './Drops/sergi'
import DropsMuwasha from './Drops/muwasha'
import DropsCerb from './Drops/cerb'
import DropsIrene from './Drops/irene'
import Binamon from './Drops/binamon'
import Halloween from './Drops/halloween'
import Swog from './Drops/swog'
import Lnkciar from './Drops/lnkciar'
import Piazze from './Drops/piazze'


const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  overflow-x: hidden;
`

const TopWrapper = styled.div`
  width: 100%;
  justify-content: space-between;
`

const ContentWrapper = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  width: 100%;
  justify-content: space-between;
  flex: 1 1 auto;
`
const FoldHeader = 'ACTIVENAV'
const HeaderWrapper = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  transition: width 0.15s linear;
  &.${FoldHeader} {
    width: 60px;
    ${({ theme }) => theme.mediaWidth.upToMedium`
      width: 0px;
    `};
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
    position: absolute;
    z-index:99;
  `};
`
const BodyContainer = styled.div`
  width: calc(100% - 208px);
  height: calc(100vh - 62px);
  overflow: auto;
  &.${FoldHeader}{
    width: calc(100% - 60px);
    ${({ theme }) => theme.mediaWidth.upToMedium`
      width: 100%;
    `};
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `};
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 70px;
  align-items: center;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 10;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding-top: 0px;
  `};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    padding: 16px;
  `};

  z-index: 1;
`

const Marginer = styled.div`
  margin-top: 5rem;
`

const Providers: React.FC = ({ children }) => {
  return (
    <YamProvider>
      <TransactionProvider>
        <FarmsProvider>
          <ModalsProvider>{children}</ModalsProvider>
        </FarmsProvider>
      </TransactionProvider>
    </YamProvider>
  )
}

export default function App() {
  const [isFold, setIsFold] = useState(false)
  const triggerFold = (fold: boolean) => {
    setIsFold(fold)
    doResize()
  }
  const doResize = () => {
    setTimeout(() => {
        //手动触发窗口resize事件, 适配首页slider
        if(document.createEvent) {
            let event = document.createEvent("HTMLEvents")
            event.initEvent("resize", true, true)
            window.dispatchEvent(event)
        }
    },230);
  }

  // 获取当前屏幕宽
  const getScreenWidth = () => {
    if(document.body.offsetWidth < +MEDIA_WIDTHS.upToMedium){
      triggerFold(true)
    }else{
      triggerFold(false)
    }
  }

  useEffect(() => {
    getScreenWidth()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Suspense fallback={null}>
      <Providers>
        <HashRouter>
          <Route component={GoogleAnalyticsReporter} />
          <Route component={DarkModeQueryParamReader} />
          <AppWrapper>
            <TopWrapper>
              <TopBakery triggerFold={triggerFold} isFold={isFold}/>
            </TopWrapper>
            <ContentWrapper>
              <HeaderWrapper className={isFold? FoldHeader : ''}>
                <Header triggerFold={triggerFold} isFold={isFold}/>
              </HeaderWrapper>
              <BodyContainer className={isFold? FoldHeader : ''} id="BodyContainer">
                <BodyWrapper>
                  <Popups />
                  <Web3ReactManager>
                    <Switch>
                      {/* <Route exact strict path="/home" component={Home} /> */}
                      {/* <Route exact strict path="/message" component={LimitIp} /> */}
                      <Route exact strict path="/home" component={NewHome} />
                      <Route exact strict path="/bakery" component={Bakery} />
                      <Route exact strict sensitive path="/bakery/:earn/:bakeryId" component={Bread} />
                      <Route exact strict sensitive path="/bakery-ten/:earn/:bakeryId" component={BreadTen} />
                      <Route exact strict sensitive path="/stakenft/:earn/:bakeryId" component={BreadNFT} />
                      <Route exact strict sensitive path="/stake/:earn/:bakeryId" component={Stake} />
                      <Route exact strict sensitive path="/tenstake/:earn/:bakeryId" component={Tenstake} />
                      <Route exact strict sensitive path="/eth2" component={Eth2} />
                      <Route exact strict sensitive path="/eth2/:earn/:bakeryId" component={eth2Child} />
                      {/* <Route exact strict path="/combo" component={Restaurant} /> */}
                      <Route exact strict sensitive path="/springfestival" component={Spring} />

                      {/* <Route exact strict path="/combo/my-combos" component={MyDishes} /> */}
                      <Route exact strict path="/my-combos" component={MyDishes} />
                      <Route exact strict path="/artworkInfo/:tokenId/:isMyArtwork/:status" component={Info} />
                      <Route path="/exchange" render={({ match: { url } }) => (
                        <ExchangeTop>
                          <Route exact path={`${url}/`} component={Exchange} />
                          <Route exact path={`${url}/bakery-artworks/:nftType`} component={PublicDigitalArtworks} />
                          <Route exact path={`${url}/pet-eggs`} component={PetEggs} />
                          <Route exact path={`${url}/weapons`} component={Weapons} />
                          <Route exact path={`${url}/digital-artworks`} component={DigitalArtworks} />
                          <Route exact path={`${url}/digital-artworks/artworkInfo/:tokenId/:isMyArtwork`} component={ArtworkInfo} />
                          <Route exact path={`${url}/binance-nft`} component={Binance} />
                          <Route exact path={`${url}/new-artworks`} component={NewArtworks} />
                          <Route exact path={`${url}/musk-doge`} component={MuskDoges} />
                          <Route exact path={`${url}/meme`} component={MeMes} />
                          <Route exact path={`${url}/seascape`} component={Seascapes} />
                          <Route exact path={`${url}/oneInch`} component={OneInchs} />
                          <Route exact path={`${url}/bakerySoccer`} component={BakerySoccer} />
                          <Route exact path={`${url}/sfpNft`} component={SfpNft} />
                          <Route exact path={`${url}/rareCar`} component={RareCarNFT} />
                          <Route exact path={`${url}/520love`} component={Love} />
                          <Route exact path={`${url}/radioCaca`} component={RacaNft} />
                          <Route exact path={`${url}/bondly`} component={bondlyNft} />
                          <Route exact path={`${url}/tokau`} component={tokauNft} />
                          <Route exact path={`${url}/doggyEquipment`} component={DoggyEquipments} />
                          <Route exact path={`${url}/new-artworks/artworkInfo/:tokenId/:isMyArtwork/:status`} component={NewArtworkInfo} />
                          <Route exact path={`${url}/bsc-artworks/artworkInfo/:tokenId/:isMyArtwork/:status`} component={BSCNewArtworkInfo} />
                          <Route exact path={`${url}/musk-doge/muskdogeInfo/:tokenId/:isMyArtwork/:status`} component={MuskDogeInfo} />
                          <Route exact path={`${url}/meme/memeInfo/:tokenId/:isMyArtwork/:status`} component={MeMeInfo} />
                          <Route exact path={`${url}/seascape/seascapeInfo/:tokenId/:isMyArtwork/:status`} component={SeascapeInfo} />
                          <Route exact path={`${url}/oneInch/oneInchInfo/:tokenId/:isMyArtwork/:status`} component={OneInchInfo} />
                          <Route exact path={`${url}/soccer/bakerySoccerInfo/:tokenId/:isMyArtwork/:status`} component={BakerySoccerInfo} />
                          <Route exact path={`${url}/520love/520loveInfo/:tokenId/:isMyArtwork/:status`} component={LoveInfo} />
                          <Route exact path={`${url}/radioCaca/radioCacaInfo/:tokenId/:isMyArtwork/:status`} component={RacaNftInfo} />
                          <Route exact path={`${url}/matrix/matrixInfo/:tokenId/:isMyArtwork/:status`} component={MatrixInfo} />
                          <Route exact path={`${url}/bakeMuskMixer/bakeMuskMixerInfo/:tokenId/:isMyArtwork/:status`} component={BakeMuskMixerInfo} />
                          <Route exact path={`${url}/toy/toyInfo/:tokenId/:isMyArtwork/:status`} component={ToyInfo} />
                          <Route exact path={`${url}/kaka/kakaInfo/:tokenId/:isMyArtwork/:status`} component={KakaInfo} />
                          {/* <Route exact path={`${url}/doggynft/doggyInfo/:tokenId/:isMyArtwork/:status`} component={DoggyNftInfo} /> */}
                          <Route exact path={`${url}/sfpNft/sfpInfo/:tokenId/:isMyArtwork/:status`} component={SfpNftInfo} />
                          <Route exact path={`${url}/bondly/bondlyInfo/:tokenId/:isMyArtwork/:status`} component={bondlyInfo} />
                          {/* <Route exact path={`${url}/artworkInfo/:tokenId/:isMyArtwork/:status`} component={Info} /> */}
                          <Route exact path={`${url}/pets`} component={Pets} />
                          <Route exact path={`${url}/tko-nft`} component={TkoNft} />
                          <Route exact path={`${url}/tkonft/tkonftInfo/:tokenId/:isMyArtwork/:status`} component={TkoNftInfo} />
                          <Route exact path={`${url}/doggynft`} component={DoggyNft} />
                          <Route exact path={`${url}/pokernft`} component={PokerNft} />
                          <Route exact path={`${url}/barkingnft`} component={BarkingNft} />
                          <Route exact path={`${url}/yooshi`} component={YooshiNft} />
                          <Route exact path={`${url}/toynft`} component={ToyNft} />
                          <Route exact path={`${url}/kakanft`} component={KakaNft} />
                        </ExchangeTop>
                      )} />
                      
                      {/**个人中心 */}
                      <Route path="/usercenter/:owner" component={UserCenterV2}></Route>
                      <Route path="/personalInfo/:owner" component={PersonalInfo}></Route>
                      {/* <Route path="/usercenterV2/:owner" component={UserCenterV2}></Route> */}


                      <Route path="/gamification" render={({ match: {url} }) => (
                        <ComboTop>
                          <Route exact path={`${url}/combomeal`} component={Restaurant} />
                          <Route exact path={`${url}/soccer`} component={GamSoccer} />
                          <Route exact path={`${url}/poker`} component={Poker} />
                          <Route exact path={`${url}/gameBox`} component={GameBox} />
                          <Route exact path={`${url}/car`} component={Car} />
                          <Route exact path={`${url}/gifbox`} component={Gifbox} />
                          <Route exact path={`${url}/doggies`} component={Doggies} />
                          <Route exact path={`${url}/barking`} component={Barking} />
                          <Route exact path={`${url}/equipment`} component={DoggyEquiments} />
                          <Route exact path={`${url}/matrix`} component={Matrix} />
                          <Route exact path={`${url}/bakeMuskMixer`} component={BakeMuskMixer} />
                          <Route exact path={`${url}/muskUsmLand`} component={MuskUsmLand} />
                          <Route exact path={`${url}/gameace`} component={GameAce} />
                        </ComboTop>
                      )}>
                      </Route>
                      <Route exact strict path="/my-giftbox" component={MyGiftBox} />
                      <Route exact strict path="/my-game-box" component={MyGameBox} />
                      <Route exact strict path="/my-eggs" component={MyEggs} />
                      <Route exact strict path="/my-weapons" component={MyWeapons} />
                      <Route exact strict path="/my-new-artworks" component={MyNewArtworks} />

                      <Route path="/collection/:nftType" component={Collection}></Route>
                      <Route path="/myArtwork/:nftType" component={MyArtwork}></Route>
                      <Route path="/explore" component={Explore}></Route>
                      <Route path="/drops/abduction-collection" component={DropsAbduction}></Route>
                      <Route path="/drops/asap" component={DropsAsap}></Route>
                      <Route path="/drops/sergi-stamp" component={DropsSergi}></Route>
                      <Route path="/drops/muwasha" component={DropsMuwasha}></Route>
                      <Route path="/drops/cerb" component={DropsCerb}></Route>
                      <Route path="/drops/irene-cerezo" component={DropsIrene}></Route>
                      <Route path="/drops/binamons" component={Binamon}></Route>
                      <Route path="/drops/halloween" component={Halloween}></Route>
                      <Route path="/drops/swog" component={Swog}></Route>
                      <Route path="/drops/lnkciar" component={Lnkciar}></Route>
                      <Route path="/drops/piazze" component={Piazze}></Route>

                      <Route exact strict path="/mint-newArtworks/:nftType" component={mintPublicArtwork} />
                      <Route exact strict path="/mint-artworks" component={mintArtworks} />
                      <Route exact strict path="/mint-muskdoge" component={mintMuskDoge} />
                      <Route exact strict path="/mint-meme" component={mintMeMe} />
                      <Route exact strict path="/mint-seascape" component={mintSeascape} />
                      <Route exact strict path="/mint-oneInch" component={mintOneInch} />
                      <Route exact strict path="/mint-sfp" component={mintSfp} />
                      <Route exact strict path="/mint-radioCaca" component={mintRacaNft} />
                      <Route exact strict path="/mint-520love" component={mintLove} />
                      <Route exact strict path="/my-pets" component={MyPets} />
                      {/* <Route exact strict path="/ido" component={BattlePets} /> */}
                      {/* <Route exact strict path="/ido/participate" component={Participate} />
                      <Route exact strict path="/ido/blink" component={Blink} />
                      <Route exact strict path="/ido/shield" component={Shield} />
                      <Route exact strict path="/ido/defi100" component={Defi100} />
                      <Route exact strict path="/ido/spartan" component={Spartan} />
                      <Route exact strict path="/ido/diesel" component={Diesel} />
                      <Route exact strict path="/ido/soccer" component={Soccer} />
                      <Route exact strict path="/ido/gamyfi" component={Gamyfi} />
                      <Route exact strict path="/ido/hyfi" component={HyFi} />
                      <Route exact strict path="/ido/petPoker" component={PetPoker} />
                      <Route exact strict path="/ido/rareCar" component={RareCar} />
                      <Route exact strict path="/ido/cryptoDoggies" component={CryptoDoggies} />
                      <Route exact strict path="/ido/tokau" component={Tokau} />
                      <Route exact strict path="/ido/xms" component={XMS} />
                      <Route exact strict path="/ido/gat" component={GAT} /> */}
                      <Route exact strict path="/swap" component={Swap} />
                      <Route exact strict path="/swap/:outputCurrency" component={RedirectToSwap} />
                      <Route exact strict path="/send" component={RedirectPathToSwapOnly} />
                      <Route exact strict path="/find" component={PoolFinder} />
                      <Route exact strict path="/pool" component={Pool} />
                      <Route exact strict path="/create" component={RedirectToAddLiquidity} />
                      <Route exact path="/add" component={AddLiquidity} />
                      <Route exact path="/add/:currencyIdA" component={RedirectOldAddLiquidityPathStructure} />
                      <Route exact path="/add/:currencyIdA/:currencyIdB" component={RedirectDuplicateTokenIds} />
                      <Route exact strict path="/remove/v1/:address" component={RemoveV1Exchange} />
                      <Route exact strict path="/remove/:tokens" component={RedirectOldRemoveLiquidityPathStructure} />
                      <Route exact strict path="/remove/:currencyIdA/:currencyIdB" component={RemoveLiquidity} />
                      <Route exact strict path="/migrate/v1" component={MigrateV1} />
                      <Route exact strict path="/migrate/v1/:address" component={MigrateV1Exchange} />
                      {/* <Route exact strict path="/create-collection" component={CreateCollection} /> */}
                      <Route component={RedirectPathToSwapOnly} />
                    </Switch>
                  </Web3ReactManager>
                  <Marginer />
                </BodyWrapper>
                {
                  false && <BodyFooter />
                }
              </BodyContainer>
            </ContentWrapper>
          </AppWrapper>
        </HashRouter>
      </Providers>
    </Suspense>
  )
}
